(() => {
  document.querySelectorAll('[data-library-navigation]').forEach(root => {
    const select = root.querySelector('[data-topic-navigation]');
    const control = root.querySelector('.nl-mobile-topics');
    if (!select || !control) return;
    select.addEventListener('change', () => { window.location.assign(select.value); });
    control.hidden = false;
    root.classList.add('nl-navigation-ready');
  });
})();
